import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import FormErrorMessage from 'components/FormErrorMessage';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { SButton, SFormCol } from './styles';
import { handleResponesWithToastify } from 'utils/globalHelpers';
import SocialMediaIcons from 'components/SocialMediaIcons';
import ReCAPTCHA from 'react-google-recaptcha';
import useAxios from 'axios-hooks';

const ContactForm = ({
  formID,
  onComplete,
  hideCopyText = false,
  firstName = '',
  lastName = '',
  phoneNumber = '',
  email = '',
  requestAs = '',
  disableAutoFill = false,
}) => {
  const [canSubmitForm, setCanSubmitForm] = useState(false);

  const [, validate_reCAPTCHA] = useAxios(
    {
      url: 'services/validate-recaptcha/',
      method: 'POST',
    },
    { manual: true },
  );
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    criteriaMode: 'all',
    defaultValues: {
      firstName,
      lastName,
      phoneNumber,
      email,
      requestAs,
      message: '',
    },
  });
  const MY_SLACK_WEBHOOK_URL =
    'https://hooks.slack.com/services/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';
  const onSubmit = async values => {
    if (canSubmitForm) {
      const data = {
        channel: '#olive-messages',
        text: `------------------------------\n*New Olive Contact Message* \n------------------------------ \n\nFirst Name: *${values.firstName}*\nLast Name: *${values.lastName}*\nEmail: ${values.email}\nI am a: *${values.requestAs}*\nPhone Number: *${values.phoneNumber}*\nMessage: *${values.message}* \n------------------------------\n------------------------------`,
        username: 'Olive Contact Message',
      };
      let response = await axios.post(
        MY_SLACK_WEBHOOK_URL,
        JSON.stringify(data),
        {
          withCredentials: false,
          transformRequest: [
            (data, headers) => {
              delete headers.post['Content-Type'];
              return data;
            },
          ],
        },
      );
      const isSuccess = response.status === 200;
      if (isSuccess) {
        reset({
          firstName: '',
          lastName: '',
          phoneNumber: '',
          email: '',
          requestAs: '',
          message: '',
        });
        onComplete();
      }
      console.log('response :>> ', response);
      handleResponesWithToastify({
        success: isSuccess,
        message: isSuccess
          ? 'Your message was sent successfully'
          : 'There was an error while sending your message, please try again.',
      });
    }
  };

  const onChangeCaptcha = async value => {
    const validate_recaptcha = await validate_reCAPTCHA({
      data: { 'g-recaptcha-response': value, request_type: 'invisible' },
    });

    if (validate_recaptcha.status === 200) {
      setCanSubmitForm(true);
    }
  };

  return (
    <Row>
      {!hideCopyText && (
        <Col md="5" lg="4" className="order-md-5 ps-md-4 mb-5 mb-md-0">
          <h2>Contact Us</h2>
          <p>
            We love hearing from our customers. If you want to book a specific
            time to talk then you can{' '}
            <a href="">book an appointment with us here.</a>
          </p>
          <SocialMediaIcons />
        </Col>
      )}
      <SFormCol
        md={hideCopyText ? '12' : '5'}
        xs="12"
        className={hideCopyText ? '' : 'offset-md-2'}
      >
        <Form
          className="form-email mx-0"
          onSubmit={handleSubmit(onSubmit)}
          id={formID}
        >
          <Row className="gy-4">
            <Col md="6" xs="12">
              <Form.Group controlId="formBasicName">
                <Form.Control
                  placeholder="First Name"
                  type="text"
                  name="firstName"
                  {...register('firstName', {
                    required: 'This field is required',
                  })}
                  disabled={firstName && disableAutoFill}
                />
                <FormErrorMessage errors={errors} name="firstName" />
              </Form.Group>
            </Col>
            <Col md="6" xs="12">
              <Form.Group controlId="formBasicName">
                <Form.Control
                  placeholder="Last Name"
                  type="text"
                  name="lastName"
                  {...register('lastName', {
                    required: 'This field is required',
                  })}
                  disabled={lastName && disableAutoFill}
                />
                <FormErrorMessage errors={errors} name="lastName" />
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group controlId="formBasicRequestAs">
                <Form.Control
                  {...register('requestAs', {
                    required: 'This field is required',
                  })}
                  name="requestAs"
                  type="text"
                  as="select"
                  aria-label="Default select example"
                  disabled={requestAs && disableAutoFill}
                >
                  <option>I am a..........</option>
                  <option value="landlord">Landlord</option>
                  <option value="tenant">Tenant</option>
                </Form.Control>
                <FormErrorMessage errors={errors} name="requestAs" />
              </Form.Group>
            </Col>
            <Col md="12">
              <Form.Group controlId="formBasicEmail">
                <Form.Control
                  disabled={phoneNumber && disableAutoFill}
                  type="text"
                  placeholder="Phone Number"
                  name="phoneNumber"
                  {...register('phoneNumber', {
                    required: 'This field is required',
                    // pattern: {
                    //   value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    //   message: 'Invalid email address',
                    // },
                  })}
                />
                <FormErrorMessage errors={errors} name="phoneNumber" />
              </Form.Group>
            </Col>

            <Col md="12">
              <Form.Group controlId="formBasicEmail">
                <Form.Control
                  type="email"
                  disabled={email && disableAutoFill}
                  placeholder="Email"
                  name="email"
                  {...register('email', {
                    required: 'This field is required',
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'Invalid email address',
                    },
                  })}
                />
                <FormErrorMessage errors={errors} name="email" />
              </Form.Group>
            </Col>
            <Col md="12" xs="12">
              <Form.Group controlId="formBasicMessage">
                <Form.Control
                  placeholder="Please let us know what you would like us to help you with by typing in the box below"
                  as="textarea"
                  rows="4"
                  name="message"
                  {...register('message', {
                    required: 'This field is required',
                  })}
                />
                <FormErrorMessage errors={errors} name="message" />
              </Form.Group>
            </Col>
            <Col xs="12">
              <ReCAPTCHA
                onErrored={() => setCanSubmitForm(false)}
                onExpired={() => setCanSubmitForm(false)}
                onChange={onChangeCaptcha}
                sitekey="6LfiX7QdAAAAAAhg04I5yxX081gkkWyvU-YQTwZe"
              />
              <SButton
                disabled={!canSubmitForm}
                type="submit"
                variant="full"
                className="w-100"
              >
                Send Enquiry
              </SButton>
            </Col>
          </Row>
        </Form>
      </SFormCol>
    </Row>
  );
};

ContactForm.propTypes = {
  formID: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  phoneNumber: PropTypes.string,
  requestAs: PropTypes.string,
  onComplete: PropTypes.func,
  hideCopyText: PropTypes.bool,
  disableAutoFill: PropTypes.bool,
};

export default ContactForm;
